import { render, staticRenderFns } from "./DisplayOffer.vue?vue&type=template&id=56a8291d&"
import script from "./DisplayOffer.vue?vue&type=script&lang=js&"
export * from "./DisplayOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports